<script>
import Layout from '@layouts/guest.vue'
import { authComputed, authMethods } from '@state/helpers'
import CreatePassword from '@guest/components/create-password.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Log in to PENCIL` }],
  },
  components: { Layout, CreatePassword },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      createPasswordError: '',
      tryingToLogIn: false,
    }
  },
  computed: { ...authComputed },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    postCreatePassword(params) {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.createPasswordError = ''
      return this.createPassword({
        password: params.password,
        confirmPassword: params.confirmPassword,
        token: this.token,
      }).then((response) => {
        if (response.message) {
          this.createPasswordError = 'non_existing_token'
        } else {
        }
      })
    },
    clearCreatePasswordErrors() {
      this.createPasswordError = ''
    },
  },
}
</script>

<template>
  <Layout>
    <CreatePassword
      :trying-to-login="tryingToLogIn"
      :create-password-error="createPasswordError"
      :is-trying-to-login="isTryingToLogin"
      @post-create-password="postCreatePassword"
      @clear-create-password-errors="clearCreatePasswordErrors"
    ></CreatePassword>
  </Layout>
</template>
